import React from "react";
import { Modal, Button } from "antd";

const MessageDialog = ({ visible, title, message, onOk, onCancel, confirm }) => {
  return (
    <Modal
      open={visible}
      title={title}
      onCancel={onCancel}
      footer={
        confirm
          ? [
              <Button key="ok" type="primary" onClick={onOk}>
                Aceptar
              </Button>,
              <Button key="cancel" onClick={onCancel}>
                Cancelar
              </Button>,
            ]
          : [
              <Button key="ok" type="primary" onClick={onOk}>
                Aceptar
              </Button>,
            ]
      }
    >
      <p>{message}</p>
    </Modal>
  );
};

export default MessageDialog;
